
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";
import arabic from "react-date-object/calendars/gregorian"; // برای عربی معمولاً میلادی با لوکال عربی
import arabic_ar from "react-date-object/locales/gregorian_ar";
import i18n from "../../i18n/index";
import DateObject from "react-date-object";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {TransformedAttachmentFile,ImageAttachmentSource,TransformedImageAttachment} from '../Types/global.types'


export const generateRandomMiniChartData = () => {
    const monthNames = ["فروردین", "اردیبهشت", "خرداد", "تیر", "مرداد", "شهریور"];

    const data = monthNames.map((month) => ({
        name: `${month} 1404`,
        value: Math.floor(Math.random() * 100),
        value1: Math.floor(Math.random() * 100),
        value2: Math.floor(Math.random() * 100),
        value3: Math.floor(Math.random() * 100),
    }));

    return data;
};

function formatNumberWithCommas(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}









const transformEnumsOptions = (data: any[] | null | undefined, title: string) => {
    if (!data) return [];

    const found = data.find(item => item.enumType === title);
    if (!found) return [];

    return found.enumValues.map((item) => ({
        key: item.description,
        value: item.id,
    }));
};

const removeIds = <T>(obj: T): T => {
    if (Array.isArray(obj)) {
        return obj.map(removeIds) as T;
    }

    if (obj !== null && typeof obj === 'object') {
        return Object.fromEntries(
            Object.entries(obj)
                .filter(([key]) => key !== 'id')
                .map(([key, value]) => [key, removeIds(value)])
        ) as T;
    }

    return obj;
};

const removeIdsIfNotRegistered = <T>(obj: T, isNested = false): T => {
    if (Array.isArray(obj)) {
        return obj.map(item => removeIdsIfNotRegistered(item, true)) as T;
    }

    if (obj !== null && typeof obj === 'object') {
        const entries = Object.entries(obj)
            .map(([key, value]) => {
                // اگه nested هستیم و type !== 'registered' بود، id رو حذف کن
                if (isNested && key === 'id' && (obj as any).type !== 'registered') {
                    return null;
                }
                return [key, removeIdsIfNotRegistered(value, isNested)];
            })
            .filter(Boolean) as [string, unknown][];

        return Object.fromEntries(entries) as T;
    }

    return obj;
};


function transformToOptions<T extends Record<string, any>>(
    list: T[],
    keyField: keyof T,
    valueField: keyof T,
    extraFields?: (keyof T)[]
) {
    return list.map((item) => ({
        key: String(item[keyField]),
        value: String(item[valueField]),
        ...(extraFields?.reduce((acc, field) => {
            acc[field] = item[field];
            return acc;
        }, {} as Partial<T>) ?? {}),
    }));
}

const calendarConfig = {
    fa: { calendar: persian, locale: persian_fa },
    en: { calendar: gregorian, locale: gregorian_en },
    ar: { calendar: arabic, locale: arabic_ar },
};

function getLocalizedDate(format = "dddd DD MMMM") {

    const lang = i18n.language as keyof typeof calendarConfig;
    const config = calendarConfig[lang] || calendarConfig.en;
    const date = new DateObject({ calendar: config.calendar, locale: config.locale });
    return date.format(format);
}





export interface ColumnDefWithKey {
    field: string;
    headerName: string; // ← کلید ترجمه، به‌جای headerName مستقیم
    flex?: number;
    width?: number;
    [key: string]: any; // برای بقیه‌ی پراپرتی‌های ColumnType (sortable, renderCell, و غیره)
}

function useTranslatedColumns<T extends ColumnDefWithKey>(



    namespace: string,
    columnDefs: T[]
) {



    const { t } = useTranslation(namespace);
    const columns = useMemo(
        () =>
            columnDefs.map(({ headerName, ...rest }) => ({
                ...rest,
                headerName: t(headerName),
            })),
        [t, columnDefs]
    );

    return columns;
}

function useTranslateWeekDay(namespace: string, list: any[]) {
    const { t } = useTranslation(namespace);

    const generatedList = useMemo(
        () =>
            list.map(({ key, ...rest }) => ({
                ...rest,

                title: t(key),
            })),
        [t, list]
    );

    return generatedList;
}





const transformFileList = (
  files: FileList | File[],
//   orderId: string = '00000000-0000-0000-0000-000000000000',
  attachmentDisplaySection: number = 1
): TransformedAttachmentFile[] =>
  Array.from(files).map((file) => ({
    // id: crypto.randomUUID(),
    title: file.name,
    fileName: file.name,
    file,
    filePath: URL.createObjectURL(file),
    attachmentDisplaySection,
    reSubmitionCounter: 0,
    // orderId,
  }));

//   ImageAttachmentSource,TransformedImageAttachment


  const transformImageAttachmentList = (
  list: ImageAttachmentSource[],
//   orderId: string  = '00000000-0000-0000-0000-000000000000',
  attachmentSection:number
): TransformedImageAttachment[] =>
  list.map((source) => ({
    // id: source.id,
    title: source.title || source.imageName,
    fileName: source.imageName,
    file: source.picture,
    filePath: source.url,
    attachmentDisplaySection:attachmentSection,
    reSubmitionCounter: 0,
    // orderId,
  }));



export {
    formatNumberWithCommas,
    transformEnumsOptions,
    removeIds,
    removeIdsIfNotRegistered,
    transformToOptions,
    getLocalizedDate,
    useTranslatedColumns,
    useTranslateWeekDay,
    transformFileList,
    transformImageAttachmentList

};